import React from "react";
import {inject, observer} from "mobx-react";
import {observable, computed} from "mobx";
import {Button} from "@material-ui/core";
import {Values} from "Tools/Values";
import Disable2FADialog from "./Disable2FADialog/Disable2FADialog";
import { Disable2FAContent } from "./styles";
import {IAuthStore} from "Stores/Auth/types";

interface IProps{
    auth?: IAuthStore;
}

@inject("auth")
@observer
export default class Disable2FA extends React.Component<IProps> {
    @observable isDialogOpened: boolean = false;
    
    @computed get isAuthenticatedWith2FA() {
        return !this.props.auth.user.isTwoFactorAuthenticationRequired
    } 

    handleDisabled() {
        this.handleCloseDialog();
    }

    handleOpenDialog() {
        this.isDialogOpened = true;
    }

    handleCloseDialog() {
        this.isDialogOpened = false;
    }

    render() {
        return (
            <>
                <Disable2FAContent>
                    <span>
                        {Values.getLocalizationValue('twoFactorAuthIsEnabled')}
                    </span>

                    {this.isAuthenticatedWith2FA ? (
                        <Button
                            variant="contained"
                            onClick={this.handleOpenDialog.bind(this)}
                            color="primary"
                            style={{marginLeft: 20}}
                        >
                            {Values.getLocalizationValue('disable')}
                        </Button>
                    ) : (
                        <span>
                            {Values.getLocalizationValue('youMustBeAuthenticatedWith2FAToDisable')}
                        </span>
                    )}
                    
                </Disable2FAContent>

                {this.isDialogOpened && (
                    <Disable2FADialog
                        isOpened={this.isDialogOpened}
                        handleClose={this.handleCloseDialog.bind(this)}
                        handleEnabled={this.handleDisabled.bind(this)}
                    />
                )}
            </>
        );
    }
}